import * as React from 'react'
import { hasText } from 'utils/helpers'

import BuilderSelectableItem from './BuilderSelectableItem'

function BuilderAddButton({
  id,
  spacingTop,
  onClick,
  colSpan = 6,
  children,
  isSelectableItem,
  type,
  containerClassNames,
  isHighlighted,
  parentPageId,
}) {
  const getContainerClassNames = React.useCallback(
    () =>
      `mt-${spacingTop ?? 2} ${colSpan > 1 ? `col-span-${colSpan}` : ''}${
        hasText ? ` ${containerClassNames}` : ''
      }`,
    [colSpan, spacingTop, containerClassNames]
  )

  if (isSelectableItem) {
    return (
      <div className={getContainerClassNames()}>
        <BuilderSelectableItem
          dataCy="add-question"
          id={id}
          parentPageId={parentPageId}
          type={type}
        >
          <div className="white flex items-center justify-center px-2 py-1 text-center">
            <p className="text-xl text-gray-400">{children}</p>
          </div>
        </BuilderSelectableItem>
      </div>
    )
  }

  return (
    <div className={getContainerClassNames()}>
      <div
        className={`px-2 py-1 bg-${
          isHighlighted ? 'zentake-200' : 'white'
        } flex cursor-pointer items-center justify-center text-center`}
        onClick={onClick}
        style={{
          overflow: 'hidden',
          borderWidth: 1,
          borderRadius: '0.25rem',
          borderColor: 'rgb(210, 214, 220)',
        }}
      >
        <p className="text-xl text-gray-400">{children}</p>
      </div>
    </div>
  )
}

export default BuilderAddButton
